import { ENV } from "../utils";

export class Record {
  baseApi = ENV.BASE_API;

  async getRecords(accessToken, active = true) {
    const url = `${this.baseApi}/records?active=${active}`;
    const response = await fetch(url, { headers: { Authorization: `Bearer ${accessToken}` } });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createRecord(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-record`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateRecord(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-record/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteRecord(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-record/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
